import React, { useEffect } from 'react'

const STYLE_ID = 'mosaic-loader-styles'

const ensureStyles = () => {
  if (typeof document === 'undefined') return
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.innerHTML = `
  @keyframes mosaicPulse {
    0% { opacity: 0.3; transform: scale(1); }
    50% { opacity: 1; transform: scale(1.05); }
    100% { opacity: 0.3; transform: scale(1); }
  }
  .mosaic-loader-square {
    animation-name: mosaicPulse;
    animation-duration: 900ms;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    will-change: transform, opacity;
  }
  `
  document.head.appendChild(style)
}

const MosaicLoader = ({ colors = ['#1d2c7a', '#273ba3', '#314acc', '#596dd7'], size = 22, text = '' }) => {
  useEffect(() => {
    ensureStyles()
  }, [])

  const squareSize = Math.max(6, Math.floor(size / 2) - 2)

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 8,
    color: 'inherit',
  }

  const gridStyle = {
    width: size,
    height: size,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const squareBase = {
    width: squareSize,
    height: squareSize,
    margin: 1,
    borderRadius: 3,
  }

  return (
    <div style={containerStyle}>
      <div style={gridStyle} aria-hidden>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="mosaic-loader-square"
            style={{
              ...squareBase,
              backgroundColor: colors[i % colors.length],
              animationDelay: `${i * 120}ms`,
            }}
          />
        ))}
      </div>
      {text ? (
        <span style={{ fontSize: 14, color: 'inherit' }}>{text}</span>
      ) : null}
    </div>
  )
}

export default MosaicLoader
